export enum TransportationOptionsActionTypes {
  TRANSPORTATION_OPTIONS_FETCH_SUCCESS = "TRANSPORTATION_OPTIONS_FETCH_SUCCESS",
  SET_TRANSPORTATION_CONFIGURATION = "SET_TRANSPORTATION_CONFIGURATION",
  TRANSPORTATION_OPTIONS_RESET_PLACEMENT_STATE = "TRANSPORTATION_OPTIONS_RESET_PLACEMENT_STATE",
  TRANSPORTATION_OPTIONS_RESET_STATE = "PLACEMENT_OPTIONS_RESET_STATE",
}
